/* eslint-disable react/destructuring-assignment */
/* eslint-disable  no-extra-boolean-cast */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { mergeClassNames } from '../../style';

export type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  icon?: JSX.Element;
  isLoading?: boolean;
  isDisabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  style?: { height?: string; width?: string };
  isLiteSim?: boolean;
};

const Button = ({
  children,
  className = '',
  icon,
  isLoading,
  isDisabled,
  onClick,
  type = 'button',
  style,
}: ButtonProps): JSX.Element => {
  const buttonClassName = mergeClassNames([
    { className: 'core-button__button' },
    { className: 'core-button__button--loading', include: Boolean(isLoading) },
    { className: 'core-button__button--disabled', include: Boolean(isDisabled) || Boolean(isLoading) },
    { className },
  ]);

  const buttonIcon = React.useMemo(
    () => (isLoading ? <i className="fa fa-spinner fa-spin core-button__button-icon" /> : icon),
    [isLoading, icon]
  );

  return (
    <button
      className={buttonClassName}
      // eslint-disable-next-line react/button-has-type
      type={type} // TypeScript guarantees correct type, but eslint rule is still complaining
      onClick={onClick}
      disabled={isDisabled || isLoading}
      style={style}
    >
      {buttonIcon} {children}
    </button>
  );
};

export type PrimaryButtonProps = ButtonProps & { danger?: boolean };

export const PrimaryButton = (props: PrimaryButtonProps): JSX.Element => {
  const buttonClassName = mergeClassNames([
    { className: props.className || '' },
    { className: 'core-button__button-primary' },
    { className: 'core-button__button-primary--danger', include: Boolean(props.danger) },
  ]);
  return <Button {...props} className={buttonClassName} />;
};

export type SecondaryButtonProps = ButtonProps & { border?: boolean };

export const SecondaryButton = (props: SecondaryButtonProps): JSX.Element => {
  const buttonClassName = mergeClassNames([
    { className: props.className || '' },
    { className: 'core-button__button-secondary' },
    { className: 'core-button__button-secondary-border', include: Boolean(props.border) },
  ]);
  return <Button {...props} className={buttonClassName} />;
};
